import PropTypes from "prop-types";
import MetaTags from "react-meta-tags";
import React from "react";

import { Row, Col, CardBody, Card, Alert, Container, Form, Input, FormFeedback, Label } from "reactstrap";

//redux
import { useSelector, useDispatch } from "react-redux";

import { withRouter, Link } from "react-router-dom";

// Formik validation
import * as Yup from "yup";
import { useFormik } from "formik";

//Social Media Imports
import { GoogleLogin } from "react-google-login";
// import TwitterLogin from "react-twitter-auth"
import FacebookLogin from "react-facebook-login/dist/facebook-login-render-props";

// actions

// import images
import logoMark from "assets/images/monitorwise-mark-dark.svg"


//Import config
import Toaster from "components/Common/Toaster";
import * as backend from "../../helpers/backend_helper"

const Login = (props: any) => {
  const dispatch = useDispatch();
  const [showPassword, setShowPassword] = React.useState(false);

  // handleValidSubmit
  const handleValidSubmit = async (values: any) => {
    try {
      let data = await backend.postJwtLogin(values);
      if (data && data.token) {
        localStorage.setItem('token', data.token)
        Toaster.success("Login Success")
        props.history.push("/dashboard")
      } else {
        Toaster.error("Login failed. Please try again.")
      }
    } catch (e) {
      Toaster.error(typeof e === "string" ? e : "Invalid email or password")
    }
  };

  const validation = useFormik({
    // enableReinitialize : use this flag when initial values needs to be changed
    enableReinitialize: true,

    initialValues: {
      email: '',
      password: '',
    },
    validationSchema: Yup.object({
      email: Yup.string().required("Please Enter Your Email"),
      password: Yup.string().required("Please Enter Your Password"),
    }),
    onSubmit: (values) => {
      handleValidSubmit(values);
    }
  });

  const { } = useSelector((state: any) => ({

  }));



  const signIn = (res: any, type: any) => {

  };

  //handleGoogleLoginResponse
  const googleResponse = (response: any) => {
    signIn(response, "google");
  };

  //handleTwitterLoginResponse
  // const twitterResponse = e => {}

  //handleFacebookLoginResponse
  const facebookResponse = (response: any) => {
    signIn(response, "facebook");
  };

  return (
    <React.Fragment>
      <MetaTags>
        <title>Login | Monitorwise</title>
      </MetaTags>
      <div className="mw-auth">
        <div>
          <div className="mw-auth-card">
            <div className="mw-auth-head">
              <div className="mw-auth-logo">
                <img src={logoMark} alt="Monitorwise" height="30" />
                <h4>MonitorWise</h4>
              </div>
              <h5>Welcome back</h5>
              <p>Sign In to Continue to MonitorWise</p>
            </div>
            <div className="mw-auth-body">
              <Form
                className="form-horizontal"
                onSubmit={(e) => {
                  e.preventDefault();
                  validation.handleSubmit();
                  return false;
                }}
              >
                <div className="mb-3">
                  <Label className="form-label">Email</Label>
                  <div className="mw-input-group">
                    <i className="mdi mdi-email-outline mw-input-icon" />
                    <Input
                      name="email"
                      className="form-control"
                      placeholder="Enter email"
                      type="email"
                      onChange={validation.handleChange}
                      onBlur={validation.handleBlur}
                      value={validation.values.email || ""}
                      invalid={
                        validation.touched.email && validation.errors.email ? true : false
                      }
                    />
                  </div>
                  {validation.touched.email && validation.errors.email ? (
                    <div className="text-danger small mt-1">{validation.errors.email}</div>
                  ) : null}
                </div>

                <div className="mb-3">
                  <Label className="form-label">Password</Label>
                  <div className="mw-input-group">
                    <i className="mdi mdi-lock-outline mw-input-icon" />
                    <Input
                      name="password"
                      value={validation.values.password || ""}
                      type={showPassword ? "text" : "password"}
                      placeholder="Enter password"
                      onChange={validation.handleChange}
                      onBlur={validation.handleBlur}
                      invalid={
                        validation.touched.password && validation.errors.password ? true : false
                      }
                    />
                    <button
                      className="mw-eye"
                      type="button"
                      onClick={() => setShowPassword(!showPassword)}
                    >
                      <i className={showPassword ? "mdi mdi-eye-off-outline" : "mdi mdi-eye-outline"} />
                    </button>
                  </div>
                  {validation.touched.password && validation.errors.password ? (
                    <div className="text-danger small mt-1">{validation.errors.password}</div>
                  ) : null}
                </div>

                <div className="mt-4 d-grid">
                  <button className="btn btn-primary" type="submit">
                    Log In
                  </button>
                </div>

                <div className="mt-3 text-center">
                  <Link to="/forgot-password" className="text-muted">
                    <i className="mdi mdi-lock me-1" />
                    Forgot your password?
                  </Link>
                </div>
              </Form>
            </div>
          </div>
          <div className="mw-auth-footer">
            <p className="mb-0" style={{ opacity: 0.6 }}>
              © {new Date().getFullYear()} MonitorWise
            </p>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default withRouter(Login);

Login.propTypes = {
  history: PropTypes.object,
};
